import { render } from "./InquiryProduct.vue?vue&type=template&id=34f23e76&scoped=true"
import script from "./InquiryProduct.vue?vue&type=script&lang=js"
export * from "./InquiryProduct.vue?vue&type=script&lang=js"

import "./InquiryProduct.vue?vue&type=style&index=0&id=34f23e76&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f23e76"]])

export default __exports__